
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-9fdbffa0&scoped=true!postcss!sass!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ReleaseSoloCustomPayProtocol.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ReleaseSoloCustomPayProtocol.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-9fdbffa0!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ReleaseSoloCustomPayProtocol.vue"),
  /* scopeId */
  "data-v-9fdbffa0",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/components/ReleaseSoloCustomPayProtocol.vue
// module id = 1004
// module chunks = 0